import { Component, OnInit, Input } from '@angular/core';
import { AppService } from 'app/main/services/app.service';
import { Lightbox } from 'ngx-lightbox';

@Component({
	selector: 'slider',
	templateUrl: './slider.component.html',
	styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

	@Input() masterImage: any;
	@Input() carousel_images: any[];

	private _album: Array<any> = [];

	constructor(
		public appService: AppService, 
		private _lightbox: Lightbox) {}

	ngOnInit(): void {
		for (let i = 0; i < this.carousel_images.length; i++) {		
			const image = this.carousel_images[i];

			this._album.push({
				src: this.appService.getBaseServerAddress() + '/document_files/download/' + image?.id
			});
		}
	}

	open(index?: number): void {
		// open lightbox
		this._lightbox.open(this._album, index, {
			centerVertically: true
		});
	}
}
